import BillingMobileRechargesService from 'js/services/api/billing/mobile-recharges.js'
import {TRANSACTIONS_TYPES, VALIDATIONS_TYPES} from 'js/lib/constants.js'

export default {
  methods: {
    platformBalance(platform) {
      return platform && platform.Balance || 0
    },

    // Pedimos las mobile_recharges del client_account, saldo pendiente de Everilion
    getPendingAmount(media, mediaType) {
      
      const params = {
        media_code: media.mediaCode,
        media_type: mediaType,
        administrative_area_id: this.administrativeArea.id
      }

      // El scope del backend nos devuelve solo las que tienen estado :queued
      return BillingMobileRechargesService.index(params).then(data => {
        const pendingAmount = _.sum(_.map(data, element => element.amount))
        this.$set(media, 'pendingAmount', pendingAmount)
        return pendingAmount
      })
    },

    getTransactionAmount(transaction) {
      
      if (transaction.type !== TRANSACTIONS_TYPES.VALIDATION) {
        return transaction.recharge_amount
      }
      if (transaction.voided_validation) {
        return 0
      }
      if (transaction.validation_type === VALIDATIONS_TYPES.FLAT_RATE) {
        return -transaction.charged_total
      }
      return -transaction.amount
    },

    getBalanceStyle(balance) {
      return balance < 0 ? 'text-danger' : 'text-info'
    },

    getAmountSymbol(transaction) {
      if (transaction.type === TRANSACTIONS_TYPES.VALIDATION) {
        return transaction.amount > 0 ? '-' : ''
      }

      return ''
    },

    getBalance(media) {
      if (media.mediaType === '1' && media.transactions && media.transactions.length > 0) {
        return media.transactions[0].balanceBefore + media.transactions[0].amount
      }
      return media.balance || 0
    }
  }
}
